import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(private logger: NGXLogger, private router: Router) {}

    ngOnInit() {
        this.logger.trace('AppComponent: NG On Init Called', location);
    }
}
